import React, { useLayoutEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import AgentChat from '../../agent/AgentChat';

// Today as a chat: the day and the score (its ring, and what's holding it
// back), then the conversation with the assistant, filling the window. No lists or briefing
// here: the Habits, Tasks, Goals and Calendar pages hold those, and the
// suggestions above the text box offer what's likely next (mark a habit done,
// a task toward a goal). On wide screens the conversation sits in a centred
// column, like a chat.

// Fill from this element's top to the bottom of the window. The page wrappers
// pad the bottom to clear the tab bar (web phones, native), so their bottom
// padding is taken off too, whatever the platform set it to.
const useFillWindow = (ref) => {
  const [height, setHeight] = useState(null);
  useLayoutEffect(() => {
    const measure = () => {
      const el = ref.current;
      if (!el) return;
      let below = 0;
      for (let node = el.parentElement; node && node !== document.body; node = node.parentElement) {
        below += parseFloat(getComputedStyle(node).paddingBottom) || 0;
      }
      const top = el.getBoundingClientRect().top + window.scrollY;
      setHeight(Math.max(420, Math.floor(window.innerHeight - top - below)));
    };
    measure();
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, [ref]);
  return height ? { height } : { height: '100dvh' };
};

const OneScreenToday = ({ colors, today, greetingText, score }) => {
  const rootRef = useRef(null);
  const fillStyle = useFillWindow(rootRef);

  return (
    <div ref={rootRef} className="flex flex-col min-h-0 max-w-[720px] mx-auto" style={fillStyle}>
      {/* The score is the one figure on the page: its ring at the right, and
          under the day, the line that says what's holding it back */}
      <header className="flex-none flex items-center justify-between gap-4 pb-3" style={{ borderBottom: `1px solid ${colors.textPrimary}` }}>
        <div className="min-w-0">
          <p className="truncate">
            <span className="text-[24px] font-semibold" style={{ color: colors.textPrimary, letterSpacing: '-0.035em' }}>
              {today.toLocaleDateString('en-US', { weekday: 'long' })}
            </span>
            <span className="font-mono text-xs ml-2" style={{ color: colors.textSecondary }}>
              {today.toLocaleDateString('en-US', { day: 'numeric', month: 'short' })}
            </span>
          </p>
          {score.line && (
            <p className="font-mono text-xs mt-1 leading-snug" style={{ color: colors.textSecondary }}>{score.line}</p>
          )}
        </div>
        <Link to={score.to} className="flex-none" aria-label={score.aria}>{score.dial}</Link>
      </header>
      <div className="flex-1 min-h-0 pt-3">
        <AgentChat fill greeting={`${greetingText}.`} />
      </div>
    </div>
  );
};

export default OneScreenToday;
